export default __webpack_public_path__ + "static/media/ArimaMadurai-Regular.e08401c9.ttf";